import ServiceSchemaError from '@/modules/core/models/errors/ServiceSchemaError'

export class CommonProperty {
  id: string
  text: string
  default?: boolean
  disabled?: boolean
  constructor(data: CommonProperty) {
    if (!data.id) {
      throw new ServiceSchemaError({ message: 'Error en la propiedad "id"' })
    }

    if (!data.text) {
      throw new ServiceSchemaError({ message: 'Error en la propiedad "text"' })
    }

    this.id = data.id
    this.text = data.text
    this.default = data.default ?? false
    this.disabled = data.disabled ?? false
  }
}

export class CopaymentTypes {
  high?: CommonProperty
  low?: CommonProperty
  withCopayment?: CommonProperty
  noCopayment: CommonProperty
  none: CommonProperty
  constructor(data: any) {
    this.high = data.high ? new CommonProperty(data.high) : undefined
    this.low = data.low ? new CommonProperty(data.low) : undefined
    this.withCopayment = data.withCopayment ? new CommonProperty(data.withCopayment) : undefined
    this.noCopayment = new CommonProperty(data.noCopayment)
    this.none = new CommonProperty(data.none)
  }
}

export class InsuranceTypes {
  health: CommonProperty
  reimbursement: CommonProperty
  abroad?: CommonProperty
  constructor(data: any) {
    if (!data.health) {
      throw new ServiceSchemaError({ message: 'Error en la propiedad "insuranceTypes.health"' })
    }

    if (!data.reimbursement) {
      throw new ServiceSchemaError({
        message: 'Error en la propiedad "insuranceTypes.reimbursement"'
      })
    }

    this.health = new CommonProperty(data.health)
    this.reimbursement = new CommonProperty(data.reimbursement)
    this.abroad = data.abroad ? new CommonProperty(data.abroad) : undefined
  }
}

export class Genders {
  female: CommonProperty
  male: CommonProperty
  constructor({ female, male }: Genders) {
    if (!female) {
      throw new ServiceSchemaError({ message: 'Error en la propiedad "genders.female"' })
    }

    if (!male) {
      throw new ServiceSchemaError({ message: 'Error en la propiedad "genders.male"' })
    }

    this.female = new CommonProperty(female)
    this.male = new CommonProperty(male)
  }
}

export class BillingCyclesModality {
  id: string
  textInFilter: string
  textInPrice: string
  discountText: string
  default?: boolean

  constructor(data: BillingCyclesModality) {
    if (!data.id) {
      throw new ServiceSchemaError({ message: 'Error en la propiedad "id"' })
    }

    if (!data.textInFilter) {
      throw new ServiceSchemaError({ message: 'Error en la propiedad "textInFilter"' })
    }

    if (!data.textInPrice) {
      throw new ServiceSchemaError({ message: 'Error en la propiedad "textInPrice"' })
    }

    if (data.discountText === undefined) {
      throw new ServiceSchemaError({ message: 'Error en la propiedad "discountText"' })
    }

    this.id = data.id
    this.textInFilter = data.textInFilter
    this.textInPrice = data.textInPrice
    this.discountText = data.discountText
    this.default = data.default ?? false
  }
}
export class BillingCycles {
  monthly: BillingCyclesModality
  quarterly: BillingCyclesModality
  semiannual: BillingCyclesModality
  annual: BillingCyclesModality

  constructor(data: BillingCycles) {
    if (!data.monthly) {
      throw new ServiceSchemaError({ message: 'Error en la propiedad "billingCycles.monthly"' })
    }

    if (!data.quarterly) {
      throw new ServiceSchemaError({ message: 'Error en la propiedad "billingCycles.quarterly"' })
    }

    if (!data.semiannual) {
      throw new ServiceSchemaError({ message: 'Error en la propiedad "billingCycles.semiannual"' })
    }

    if (!data.annual) {
      throw new ServiceSchemaError({ message: 'Error en la propiedad "billingCycles.annual"' })
    }

    this.monthly = new BillingCyclesModality(data.monthly)
    this.quarterly = new BillingCyclesModality(data.quarterly)
    this.semiannual = new BillingCyclesModality(data.semiannual)
    this.annual = new BillingCyclesModality(data.annual)
  }
}

export class HouseTypes {
  apartment: CommonProperty
  house: CommonProperty

  constructor(data: HouseTypes) {
    if (!data.apartment) {
      throw new ServiceSchemaError({ message: 'Error en la propiedad "houseTypes.apartment"' })
    }

    if (!data.house) {
      throw new ServiceSchemaError({ message: 'Error en la propiedad "houseTypes.house"' })
    }

    this.apartment = new CommonProperty(data.apartment)
    this.house = new CommonProperty(data.house)
  }
}

export class StayAbroadTypes {
  work: CommonProperty
  study: CommonProperty

  constructor(data: StayAbroadTypes) {
    if (!data.work) {
      throw new ServiceSchemaError({ message: 'Error en la propiedad "stayAbroadTypes.work"' })
    }

    if (!data.study) {
      throw new ServiceSchemaError({ message: 'Error en la propiedad "stayAbroadTypes.study"' })
    }

    this.work = new CommonProperty(data.work)
    this.study = new CommonProperty(data.study)
  }
}
